module.exports = __webpack_public_path__ + "static/fonts/icomoon.a46c6ca.woff";